export default __webpack_public_path__ + "static/lora-case-study-83821bceb333836d5d8b544096aeb95d.webp";